import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import LoginComponent from '../components/signup/LoginComponent';
import SignupComponent from '../components/signup/SignupComponent';


const AuthPage = () => {
  const [authStep, setAuthStep] = useState(0); // 0 = SimpleLogin, 1 = Login, 2 = SimpleLogin
  const navigate = useNavigate();
  const auth = getAuth();
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      const flag = JSON.parse(localStorage.getItem("Authenticate"));
      if (user || flag) {
        navigate("/map-selector");
      }
    });
    return () => unsubscribe();
  }, [navigate]);
  

  const switchAuthModeHandler = () => {
    setAuthStep((prevStep) => (prevStep + 1) % 2); // Cycle between 0, 1, and 2
  };

  return (
    <div>
      {/* {authStep === 0 && <SimpleLogin onSwitchMode={switchAuthModeHandler} />} */}
      {authStep === 0 && <LoginComponent onSwitchMode={switchAuthModeHandler} />}
      {authStep === 1 && <SignupComponent onSwitchMode={switchAuthModeHandler} />}
    
    

    </div>
  );
};

export default AuthPage;
